<template>
  <div>
    <div class="d-flex mb-4">
      <div class="titulo-pagina">
        {{ tituloFormulario }}
      </div>
    </div>

    <v-form ref="form" class="row">
      <input-text
        v-model="form.descricao"
        class="col-12 col-md-3"
        :label="$t('modulos.imagem_servico.formulario.nome')"
        :max="200"
        trim
        obrigatorio
      />

      <input-file
        returns="base64"
        class="col-12 col-md-4"
        obrigatorio
        :placeholder="$t('modulos.imagem_servico.formulario.imagem')"
        :image="form.imagem"
        :value="form.imagemFile"
        @nome-imagem="nomeImagem"
        @handle-upload="handleUpload"
      />
    </v-form>
    <v-divider class="my-5" />

    <tabela-padrao-prime-vue
      ref="tabela"
      v-model="tabela.selecionados"
      class="mt-2"
      :colunas="tabela.colunas"
      :dados="tabela.dados"
      :mostrar-acoes="false"
      filtros-com-colunas
      :mostrar-seletor="buscarPermissao('ServicoManutencao', 'Deletar')"
      :quantidade-itens="tabela.quantidadeItens"
      :por-pagina="tabela.porPagina"
      :quantidade-paginas="tabela.quantidadePaginas"
      :pagina="tabela.paginaAtual"
      @paginar="buscarServicos"
      @filtrarGlobal="buscarServicos"
      @filtroGlobal="(v) => (filtroAplicado.filter = v)"
      @nova-ordenacao="ordenacaoColuna"
    >
      <template v-slot:valorServico="{ slotProps }">
        <div class="alinhar-direita">
          {{ formatacaoMoeda(slotProps.data.valorServico) }}
        </div>
      </template>
      <template v-slot:faixa="{ slotProps }">
        <div
          v-if="
            slotProps.data.amplitudeMinima || slotProps.data?.amplitudeMaxima
          "
          class="alinhar-direita"
        >
          {{
            faixaFormatada(`(${slotProps.data?.amplitudeMinima + ' a '}
            ${slotProps.data?.amplitudeMaxima})
            ${slotProps.data?.unidadeMedida?.simbolo || ''}`)
          }}
        </div>
      </template>
    </tabela-padrao-prime-vue>
    <v-divider class="my-5" />
    <div class="d-flex align-center justify-end">
      <botao-padrao outlined color="secondary" class="mr-2" @click="cancelar">
        <v-icon>$mdiCancel</v-icon>
        {{ $t('geral.botoes.cancelar') }}
      </botao-padrao>
      <botao-padrao @click="confirmacaoSalvar">
        <v-icon>$mdiContentSaveOutline</v-icon>
        {{ $t('geral.botoes.salvar') }}
      </botao-padrao>
    </div>
  </div>
</template>
<script>
import ImagemServicoService from '@common/services/cadastros/ImagemServicoService';
import ServicoService from '@common/services/cadastros/ServicoService';
import helpers from '@common/utils/helpers';
import { InputFile } from '@components/inputs';
import _ from 'lodash';

export default {
  components: {
    InputFile,
  },
  props: ['id'],
  data() {
    return {
      valorTipoChecklist: null,
      indiceAba: 0,
      form: {},
      filtroAplicado: { filter: '' },
      erros: [],
      colunaOrdenada: '',
      tabela: {
        selecionados: [],
        dados: [],
        colunas: [
          {
            value: 'codigo',
            text: this.$t('modulos.servico_manutencao.tabela.codigo'),
            sortable: true,
          },
          {
            value: 'tipoServico',
            text: this.$t('modulos.servico_manutencao.tabela.tipo_servico'),
            sortable: true,
          },
          {
            value: 'nome',
            text: this.$t('modulos.servico_manutencao.tabela.nome'),
            sortable: true,
          },
          {
            value: 'localExecucao.nome',
            text: this.$t('modulos.servico_manutencao.tabela.local_execucao'),
            sortable: true,
          },
          {
            value: 'faixa',
            text: this.$t('modulos.servico_manutencao.tabela.faixa'),
            sortable: true,
          },
          {
            value: 'tipoCalibracao.nome',
            text: this.$t('modulos.servico_calibracao.tabela.tipo_calibracao'),
            sortable: true,
          },
          {
            value: 'valorServico',
            text: this.$t('modulos.servico_manutencao.tabela.valor_servico'),
            sortable: true,
            formatter: (v) => helpers.formatarMoeda(v),
          },
        ],
        quantidadeItens: 0,
        quantidadePaginas: 0,
        paginaAtual: 1,
        porPagina: 10,
      },
    };
  },
  computed: {
    tituloFormulario: function () {
      if (this.id) return this.$t('modulos.imagem_servico.titulos.editar');
      return this.$t('modulos.imagem_servico.titulos.novo');
    },
    regras() {
      let regras = _.cloneDeep(this.regrasPersonalizadas);
      if (this.obrigatorio) regras.push(this.validacaoObrigatorio);

      return regras;
    },
  },
  watch: {
    'tabela.dados': function (novosDados) {
      if (novosDados.length > 0 && this.form.servicos) {
        const idsSelecionados = this.form.servicos.map(
          (servico) => servico.servicoId
        );
        this.$refs.tabela.selecionados = novosDados.filter((dado) =>
          idsSelecionados.includes(dado.id)
        );
      }
    },
  },
  mounted() {
    this.buscarServicos();

    if (this.id) {
      helpers.redirecionarSemPermissao(this, 'ImagenServico', 'Editar');
      this.buscar();
    }
    helpers.redirecionarSemPermissao(this, 'ImagenServico', 'Inserir');
    this.$store.dispatch('Layout/alterarTituloPagina', this.tituloFormulario);
  },
  methods: {
    filtrarGlobal() {
      this.buscarServicos();
    },
    filtrar: function (filtro) {
      this.filtroAplicado = { ...filtro, filter: this.filtroAplicado.filter };
      this.buscarServicos();
    },
    buscarServicos: function (
      paginaAtual = this.tabela.paginaAtual,
      porPagina = this.tabela.porPagina
    ) {
      this.tabela.porPagina = porPagina;
      helpers.salvarStateFiltros(this, {
        filtroAplicado: this.filtroAplicado,
        paginaAtual,
        porPagina,
      });

      let parametros = {
        page: paginaAtual,
        amountPerPage: porPagina,
        ...helpers.formattingParameters(this.filtroAplicado),
        sort: this.colunaOrdenada,
      };
      this.$store.dispatch('Layout/iniciarCarregamento');
      this.tabela.dados = [];
      ServicoService.listar(parametros)
        .then((res) => {
          this.tabela.dados = res.data.items;
          this.tabela.quantidadeItens =
            res.data.totalItems ?? this.tabela.dados.length;

          this.tabela.quantidadePaginas = res.data.totalPages;
          this.tabela.paginaAtual = paginaAtual;
          this.tabela.porPagina = porPagina;
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    buscar: function () {
      ImagemServicoService.buscar(this.id)
        .then((res) => {
          this.form.id = res.data.id;
          this.form.descricao = res.data.nome;
          this.form.imagem = res.data.imagem;
          this.form.imagemFile = this.base64ParaFile(res.data.imagem);
          this.form.servicos = res.data.servicos;
          this.$nextTick(() => {
            const idsSelecionados = res.data.servicos.map(
              (servico) => servico.servicoId
            );
            this.$refs.tabela.selecionados = this.tabela.dados.filter((dado) =>
              idsSelecionados.includes(dado.id)
            );
          });
        })
        .catch(() => {
          this.toastErro(this.$t('modulos.imagem_servico.erros.id_invalido'));
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    base64ParaFile: function (base64String, defaultFileName = 'imagem.png') {
      const [header, base64] = base64String.split(',');
      const mimeMatch = header.match(/:(.*?);/);
      const mimeType = mimeMatch ? mimeMatch[1] : 'application/octet-stream';
      const fileExtension = mimeType.split('/')[1] || 'png';
      const fileName = defaultFileName.endsWith(`.${fileExtension}`)
        ? defaultFileName
        : `imagem.${fileExtension}`;

      const binaryString = window.atob(base64);
      const arrayBuffer = new ArrayBuffer(binaryString.length);
      const uint8Array = new Uint8Array(arrayBuffer);

      for (let i = 0; i < binaryString.length; i++) {
        uint8Array[i] = binaryString.charCodeAt(i);
      }

      const blob = new Blob([uint8Array], { type: mimeType });

      return new File([blob], fileName, { type: mimeType });
    },
    confirmacaoSalvar: function () {
      if (this.id) {
        this.confirmarSalvar().then(() => {
          this.salvar();
        });
      } else this.salvar();
    },
    manipularServicos: function () {
      if (this.id) {
        const idsSelecionados = this.tabela.selecionados.map(
          (servico) => servico.id
        );
        const servicosExistentesMap = new Map(
          this.form.servicos.map((servico) => [servico.servicoId, servico])
        );
        const servicosAtualizados = idsSelecionados.map((id) => ({
          servicoId: id,
        }));

        this.form.nome = this.form.descricao;
        this.form.servicos = [
          ...Array.from(servicosExistentesMap.values()),
          ...servicosAtualizados.filter(
            (servico) => !servicosExistentesMap.has(servico.servicoId)
          ),
        ];
      } else {
        this.form.servicos = this.tabela.selecionados.map((servico) => {
          return {
            servicoId: servico.id,
          };
        });
      }
    },
    salvar: function () {
      if (!this.$refs.form.validate()) return;
      if (this.tabela.selecionados.length === 0) {
        this.toastAlerta(
          this.$t('modulos.imagem_servico.erros.selecione_servico')
        );
        return;
      }

      this.manipularServicos();

      this.$store.dispatch('Layout/iniciarCarregamento');
      ImagemServicoService.salvar(this.form)
        .then(() => {
          this.$router.push({ name: 'imagem-servico' });
          this.toastSucesso(this.$t(`modulos.imagem_servico.cadastro_sucesso`));
        })
        .catch((err) => {
          this.toastErro(this.$t(`geral.erros.${err.response.data.errors[0]}`));
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    cancelar: function () {
      this.confirmarCancelar().then(() => {
        this.$router.push({ name: 'imagem-servico' });
      });
    },
    handleUpload: function (file) {
      this.form.imagem = file;
    },
    nomeImagem: function (nomeImagem) {
      this.form.nomeExtensaoImagem = nomeImagem;
    },
    formatacaoMoeda(valor) {
      if (valor) return helpers.formatarMoeda(valor);
    },
    faixaFormatada(value) {
      return String(value).replaceAll('.', ',');
    },
    buscarPermissao(funcionalidade, funcionalidadeAcao) {
      return helpers.buscarStatePermissoes(
        this,
        funcionalidade,
        funcionalidadeAcao
      );
    },
    ordenacaoColuna(ordem) {
      this.colunaOrdenada = ordem;
      this.buscarServicos();
    },
  },
};
</script>
